import {
  BREAKPOINT_DESKTOP_LG,
  BREAKPOINT_MOBILE,
  useMount,
} from "../constants/constants";
import { updateTrendsPageFilterState } from "../providers/GlobalStateProvider";
import { askrClients } from "../providers/AskrProvider";
import { useDispatch } from "react-redux";
import TrendsPageTopBar from "../components/FlightTrends/TrendsPageTopBar";
import { TrendsPageStyles } from "../components/FlightTrends/TrendsPageStyles";
import {
  TrendChartSectionCollapsible,
  PnlBreakdownSectionCollapsible,
  TimelineSection,
  ButterflyAndMetricsSectionCollapsible,
  MachineBreakdownSectionCollapsible,
} from "../components/FlightTrends/TrendsPageSections";
import {
  useDetectDoesCustomerHaveCounts,
  useTrendsPageFilterState,
} from "../utils/customHooks/genericHooks";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";

import { createAllProcessGroup } from "../components/FlightTrends/TrendsFilters/filtersDrawerUtils";
import PnlChartPopup from "components/Dashboard/TrendChart/TrendChartContent/PnlChartPopup/PnlChartPopup";
import SyncTrendsPageFilterStateToUrl from "components/SimpleComponents/SyncFilterStateToUrl";
import FilterStateDisplay from "components/FlightTrends/TrendsFilters/FilterStateDisplay";
import { ApolloProvider } from "@apollo/client";
import ServiceOutageIndicator from "components/SimpleComponents/TopBanner/ServiceOutageIndicator";
import { css } from "styled-components/macro";
import { TrendsPageMisconfiguredWarning } from "components/FlightTrends/TrendsPageMisconfiguredWarning";
import styled, { createGlobalStyle } from "styled-components/macro";
import { useMediaQuery } from "@mui/material";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

const TrendsPage = () => {
  const ckey = useCustomerKey();

  if (!ckey) {
    return null;
  }
  return (
    <ApolloProvider client={askrClients.get(ckey)}>
      <InitializeTrendsPage />
      <SyncTrendsPageFilterStateToUrl />
      <TrendsPageGlobalStyles />
      <TrendsPageStyles>
        <TrendsPageContent />
      </TrendsPageStyles>
    </ApolloProvider>
  );
};

export default TrendsPage;

const TrendsPageGlobalStyles = createGlobalStyle`
html{overflow:hidden;}
`;

function TrendsPageContent() {
  const isDesktopLgOrLarger = useMediaQuery(
    `(min-width: ${BREAKPOINT_DESKTOP_LG}px)`
  );
  const [
    {
      general: { enableMachineBreakdownChart },
    },
  ] = useFlightConfig();
  return (
    <TrendsPageContentStyles>
      <TrendsPageTopBar />
      <TrendsPageMisconfiguredWarning />
      <ServiceOutageIndicator
        customCss={css`
          margin: 5px 5px 0;
          @media (min-width: ${BREAKPOINT_MOBILE}px) {
            margin: 10px 10px 0;
          }
          position: fixed;
          z-index: 1000;
          bottom: 8px;
          opacity: 0.9;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
          left: 0;
          right: 0;
        `}
      />
      <div
        className={`trendsPageStyles`}
        style={{
          border: "none",
          paddingTop: "0px",
        }}
      >
        {isDesktopLgOrLarger ? null : (
          <div className="cardItem Card_FilterStateDisplay">
            <FilterStateDisplay />
          </div>
        )}
        <ButterflyAndMetricsSectionCollapsible />
        <TrendChartSectionCollapsible />
        <PnlBreakdownSectionCollapsible />
        {enableMachineBreakdownChart && <MachineBreakdownSectionCollapsible />}
        <TimelineSection />
      </div>
      <PnlChartPopup />
    </TrendsPageContentStyles>
  );
}
const TrendsPageContentStyles = styled.div`
  @media (max-width: ${BREAKPOINT_MOBILE}px) {
  }
`;

function InitializeTrendsPage() {
  // create the "all" process group
  useCreateAllProcessGroupOnMount();

  // detect if the customer uses counts
  useDetectDoesCustomerHaveCounts();

  return null;
}

/** set proper "all" process on mount (it initially loads with an empty ckey) */
function useCreateAllProcessGroupOnMount() {
  const { trendsPageFilterState } = useTrendsPageFilterState();
  const ckey = useCustomerKey();
  const dispatch = useDispatch();

  useMount(() => {
    const needToUpdateAllProcessGroup =
      trendsPageFilterState.process.name.toLowerCase() === "all" &&
      trendsPageFilterState.process.ckey === "";

    if (needToUpdateAllProcessGroup) {
      const newAllProcessGroup = createAllProcessGroup(ckey);
      const allProcess = newAllProcessGroup.processes[0];
      dispatch(
        updateTrendsPageFilterState({
          newFilterState: { ...trendsPageFilterState, process: allProcess },
        })
      );
    }
  });
}
